import "./styles/_tab-bar.scss"
import { TabBarArrowLeft } from "./ui/TabBarArrowLeft"
import { TabBarArrowRight } from "./ui/TabBarArrowRight"
import { TabBarRoot } from "./ui/TabBarRoot"
import { TabBarScrollContent } from "./ui/TabBarScrollContent"
import { TabBarScrollGroup } from "./ui/TabBarScrollGroup"
import { TabBarTab } from "./ui/TabBarTab"

export const TabBar = {
  Root: TabBarRoot,
  Tab: TabBarTab,
  ScrollGroup: TabBarScrollGroup,
  ScrollContent: TabBarScrollContent,
  ArrowLeft: TabBarArrowLeft,
  ArrowRight: TabBarArrowRight
}

export type { TabBarRootProps } from "./ui/TabBarRoot"
